import React, { useState } from 'react';
import { Search, Filter, RefreshCw } from 'lucide-react';
import { useAcmBase } from '../../hooks/useAcmBase';

export function MobileStudentsPage() {
  const [searchTerm, setSearchTerm] = useState('');
  const { data: students, loading, refresh } = useAcmBase();

  return (
    <div className="p-4 pt-16">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-xl font-bold text-white">Alunos</h1>
        <button
          onClick={refresh}
          disabled={loading}
          className="p-2 bg-[#1A1D23] text-gray-300 rounded-lg"
        >
          <RefreshCw className={`w-5 h-5 ${loading ? 'animate-spin' : ''}`} />
        </button>
      </div>

      <div className="mb-4">
        <div className="relative">
          <Search className="w-5 h-5 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2" />
          <input
            type="text"
            placeholder="Buscar alunos..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full bg-[#1A1D23] text-white rounded-lg pl-10 pr-4 py-3 border border-gray-700 focus:border-indigo-500 focus:outline-none"
          />
        </div>
      </div>

      <div className="space-y-4">
        {students.map((student) => (
          <div key={student.email} className="bg-[#1A1D23] p-4 rounded-lg">
            <h3 className="font-medium text-white">{student.nome}</h3>
            <p className="text-gray-400 text-sm mt-1">{student.email}</p>
            <div className="mt-2 flex flex-wrap gap-2">
              {student.cursos?.map((curso, index) => (
                <span
                  key={index}
                  className="text-xs bg-[#268c73]/20 text-[#268c73] px-2 py-1 rounded"
                >
                  {curso.nome_curso}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}